import { webKnots } from 'src/features/brands/atoms/canvas/common/back/lace/webKnots'
import { crossLace } from '../lace/crossLace'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import {
  verticalPartOfWebForJoint,
  verticalPartOfWebWithLace,
  verticalPartOfWebWithLaceForJoint,
  verticalPartOfWebWithLaceWithEdge
} from './parts/verticalParts'

export const crossWebWithCenterLaceWithCrossLace = (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLace(ctx, webColor2 || webColor, laceColor, stitchColor)
  crossLace(ctx, laceColor, 0, 0, 1, 1)
  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -135, 145) // 捕球面上のウェブ結び目
}

export const crossWebWithLaceWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLaceWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)

  webKnots(ctx, laceColor, -80, 90) // クロス中央の結び目
  webKnots(ctx, laceColor, -130, 140) // 捕球面上のウェブ結び目
}

export const crossJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  const webColor2 = webColor
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, webColor2, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebForJoint(ctx, webColor, laceColor, stitchColor)
  // 結び目
  webKnots(ctx, laceColor, -110, 120)
}

export const crossJointWebWithLace = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  const webColor2 = webColor
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, webColor2, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLaceForJoint(ctx, webColor, laceColor, stitchColor)

  webKnots(ctx, laceColor, -90, 100) // クロス中央の結び目
  webKnots(ctx, laceColor, -110, 120) // 捕球面上のウェブ結び目
}
